type Props = {
    type: string;
    label: string;
    pattern: string;
    title: string;
    inputValue: string;
    setInputValue: (inputValue: string) => void;
    autoComplete?: string;
    options?: { value: string; label: string }[];
}

const Input = ({
    type,
    label,
    pattern,
    title,
    inputValue,
    setInputValue,
    autoComplete,
    options
}: Props) => {

    return (
        <div className="w-full">
            <div className="relative mb-4 h-12 w-full">
                {type === "select" ? (
                    <select
                        name={label}
                        value={inputValue}
                        onChange={(e) => setInputValue(e.target.value)}
                        required
                        className="peer h-full w-full rounded-[7px] border border-gray-300 bg-transparent px-3 py-2.5 text-sm text-gray-700 outline-none transition-all focus:border-2 focus:border-secondary focus:outline-none focus:ring-0"
                    >
                        {options?.map((option) => (
                            <option key={option.value} value={option.value}>
                                {option.label}
                            </option>
                        ))}
                    </select>
                ) : (
                    <input
                        type={type}
                        name={label}
                        autoComplete={autoComplete}
                        placeholder=" "
                        value={inputValue}
                        pattern={pattern ? pattern : undefined}
                        title={title ? title : undefined}
                        onChange={(e) => setInputValue(e.target.value)}
                        required
                        className={`peer h-full w-full rounded-[7px] border ${inputValue ? "border-t-transparent" : "border-gray-300"
                            } bg-transparent px-3 py-2.5 text-sm text-gray-700 outline-none transition-all
                        placeholder-shown:border
                        placeholder-shown:border-gray-300
                        placeholder-shown:border-t-gray-300
                        focus:border-2
                        focus:border-secondary
                        focus:border-t-transparent
                        focus:outline-none
                        focus:ring-0
                        disabled:border-0
                        disabled:bg-gray-50`}
                    />
                )}

                {type !== "select" && (
                    <label
                        htmlFor={label}
                        className="pointer-events-none absolute left-0 -top-1.5 flex h-full w-full select-none text-[11px] font-normal leading-tight text-slate-500 transition-all
                        before:pointer-events-none
                        before:mt-[6.5px]
                        before:mr-1
                        before:block
                        before:h-1.5
                        before:w-2.5
                        before:rounded-tl-md
                        before:border-l
                        before:border-t
                        before:border-gray-300
                        before:transition-all
                        before:content-['']

                        after:pointer-events-none
                        after:mt-[6.5px]
                        after:ml-1
                        after:block
                        after:h-1.5
                        after:flex-grow
                        after:rounded-tr-md
                        after:border-r
                        after:border-t
                        after:border-gray-300
                        after:transition-all
                        after:content-['']

                        peer-placeholder-shown:text-sm
                        peer-placeholder-shown:leading-[3.75]
                        peer-placeholder-shown:text-gray-500
                        peer-placeholder-shown:before:border-transparent
                        peer-placeholder-shown:after:border-transparent

                        peer-focus:text-[11px]
                        peer-focus:leading-tight
                        peer-focus:text-secondary
                        peer-focus:before:border-l-2
                        peer-focus:before:border-t-2
                        peer-focus:before:border-secondary
                        peer-focus:after:border-r-2
                        peer-focus:after:border-t-2
                        peer-focus:after:border-secondary

                        peer-disabled:text-transparent
                        peer-disabled:before:border-transparent
                        peer-disabled:after:border-transparent
                        peer-disabled:peer-placeholder-shown:text-gray-500"
                    >
                        {label}
                    </label>
                )}
            </div>
        </div>
    );
}
export default Input